var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9002 11.9L14.0002 14M13.4002 7.7C13.4002 10.848 10.8483 13.4 7.70024 13.4C4.55222 13.4 2.00024 10.848 2.00024 7.7C2.00024 4.55198 4.55222 2 7.70024 2C10.8483 2 13.4002 4.55198 13.4002 7.7Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14289 5.52709C9.14289 6.36292 8.48605 7.0405 7.6758 7.0405C6.86555 7.0405 6.20871 6.36292 6.20871 5.52709C6.20871 4.69125 6.86555 4.01367 7.6758 4.01367C8.48605 4.01367 9.14289 4.69125 9.14289 5.52709Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2432 9.68898C10.2432 10.5248 9.09374 11.2024 7.6758 11.2024C6.25786 11.2024 5.1084 10.5248 5.1084 9.68898C5.1084 8.85315 6.25786 8.17557 7.6758 8.17557C9.09374 8.17557 10.2432 8.85315 10.2432 9.68898Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.1a2f13fe5f92ff3f29a10fd9b9b78316.svg";
export { ForwardRef as ReactComponent };